import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2'
import moment from "moment";
import { format } from 'date-fns';
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import HomeIcon from '@material-ui/icons/Home';
import FormControl from '@material-ui/core/FormControl';
import LocationCitySharpIcon from '@material-ui/icons/LocationCitySharp';
import ListAltIcon from '@material-ui/icons/ListAlt';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';

import MaterialInputListCreate from '../MaterialsInput/MaterialInputListCreate';
import MaterialInputListEdit from '../MaterialsInput/MaterialInputListEdit';
import MaterialInputListEditDbClick from '../MaterialsInput/MaterialInputListEditDbClick';
import MaterialInputListDelete from '../MaterialsInput/MaterialInputListDelete';
import MatrialInputListMessage from '../MaterialsInput/MatrialInputListMessage';
import { colors } from '@material-ui/core';


const excelIcon = '/icons/excel48.ico';
const ExcelJS = require('exceljs');

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },

  root: {
    width: '18px',
    height: '18px',
    margin: '5px 0px 0px 0px',
    padding: '0px 0px 0px 5px',
  },
  // Applied to <FormControlLabel />
  label: {
    fontSize: 12,
    margin: '8px 0px 0px 0px',
    padding: '0px 0px 0px 5px',
    // border: '1px solid blue'
  },
}
));


function MaterialInputList() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  const [pwNoName, setPwNoName] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료
  const gridRef = useRef();
  const [materialInputList, setMateriaInputList] = useState([]);
  const [materialInputListSelectData, setMaterialInputListSelectData] = useState([]);

  const [materialInputListGojangGubun, setMaterialInputListGojangGubun] = useState(''); //공장구분
  const [supplier, setSupplier] = useState(null); //업체명/코드
  const [materialInputListCode, setMaterialInputListCode] = useState(''); //자재규격
  const [materialInputListGubun, setMaterialInputListGubun] = useState(''); //자재구분
  const [materialInputListIpChulGubun, setMaterialInputListIpChulGubun] = useState('입고'); //자재입고출고 라디오버튼
  const [materialInputListNameChange, setMaterialInputListNameChange] = useState(''); //검색클릭값전달
  const [materialInputListEditValue, setMaterialInputListEditValue] = useState(''); // edit Id저장하기
  const [materialInputListDeleteValue, setMaterialInputListDeleteValue] = useState(''); // delete 자료props 삭제하기
  const [materialInputListCreateModal, setMaterialInputListCreateModal] = useState(false); //자료등록모달
  const [materialInputListEditModal, setMaterialInputListEditModal] = useState(false); //자료수정모달
  const [materialInputListEditDbClickModal, setMaterialInputListEditDbClickModal] = useState(false); //자료수정모달 결재처리 더블클릭
  const [materialInputListDeleteModal, setMaterialInputListDeleteModal] = useState(false); //자료삭제모달
  const [materialInputListPasswordTrue, setMaterialInputListPasswordTrue] = useState(false); //삭제자료조건 스테이터
  const [matrialInputListMessageModal, setMatrialInputListMessageModal] = React.useState(false);  //메세지모달 2024-01-01부터 메시지나타내지 않음


  const [startDate, setStartDate] = useState(''); //검색시작날짜
  const [endDate, setEndDate] = useState(''); //검색끝날날짜
  const [groupbyGuljeDal, setGroupbyGuljeDal] = useState(); //결재지급달
  const [groupby, setGroupby] = useState(); //집계방법(개별,그롭)

  const [cellEditMigul, setCellEditMigul] = useState([]); // cell 수정 배열담기


  const classes = useStyles();
  //히스토리사용
  const history = useHistory();

  const customRadio = <Radio size='small' color="primary" classes={{ root: classes.root }} />;


  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    setPwNoName(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    setStartDate(moment().startOf('month').format('YYYY-MM-DD')) //시작일자
    setEndDate(moment().endOf('month').format('YYYY-MM-DD'))   //끝날일자
    if (pwloading !== urlpw) {
      // window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login');
    }
    else {
    }
    // refreshPurchaseMaterialList()
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료;


  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        setMaterialInputListSelectData(res.data);
      })
  }, [])

  //삭제조건 실행(materialDelete 모듈의 setPurchaseDeleteModal 변경시 싱행함)
  useEffect(() => {
    if (materialInputListPasswordTrue === true) {
      onDelete()
      setMaterialInputListPasswordTrue(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialInputListPasswordTrue])

  //지급금액 변경시 랜더링
  const editRendering = (() => {
    const urlButtonSerche = '/api/MaterialsInputList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, {
      params: {
        materialGojang: cellEditMigul.공장구분,
        materialUpcheCode: cellEditMigul.업체코드,
        materialCode: cellEditMigul.자재규격,
        materialGubun: cellEditMigul.자재구분,
        materialStartDate: cellEditMigul.시작일자,     //시작일자
        materialEndDate: cellEditMigul.끝날일자,       //끝날일자
        materialGuljeDal: cellEditMigul.결지지월,        //결재지급월
        materialGroupby:cellEditMigul.합계선택,        //합계선택
        materialIpChulGubun: cellEditMigul.입고출고    //자재입고출고 구분
      }
    })
      .then((res) => {
        setMateriaInputList(res.data);
      })
  })

  //공장구분변경
  const materialInputListGongjangGubunHandle = ((e) => {
    // e.preventDefault()
    setMaterialInputListGojangGubun(e.target.value)
  })

  //구매업체리스트값가지오기
  const haneleSuppilerOnClick = ((e) => {
    //setMaterialInputListNameChange('')
  })

  //자재규격 클릭했을때
  const haneleMaterialInputListCodeOnClick = ((e) => {
    //setMaterialInputListNameChange('')
  })
  //자재규격값변경 했을때
  const haneleMaterialInputListCodeOnChange = ((e) => {
    // e.preventDefault()
    setMaterialInputListCode(e.target.value)
  })

  //자재공정 클릭했을때
  const haneleMaterialGubunOnClick = ((e) => {
    //setMaterialInputListNameChange('')
  })

  //자재공정 변경했을때
  const haneleMaterialInputListGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialInputListGubun(e.target.value)
  })

    //결재달 클릭했을때
    const haneleGroupbyGuljeDalOnClick = ((e) => {
      //setMaterialInputListNameChange('')
    })

    //결재달값 변경했을때
    const haneleGroupbyGuljeDalOnChange = ((e) => {
      e.preventDefault()
      setGroupbyGuljeDal(e.target.value)
    })


  //집계방법 변경했을때
  const materialInputListGroupbyGubunHandle = ((e) => {
    // e.preventDefault()
    setGroupby(e.target.value)
  })

  //입고, 출고구분 선택했을때
  const haneleMaterialInputListIpChulGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialInputListIpChulGubun(e.target.value)
  })


  //검색클릭 값변경
  const handleMaterialInputListNameChange = (e) => {
    e.preventDefault();
    setMaterialInputListNameChange(e.target.value);
  };
  //검색엔트 실행
  const handleMaterialInputListNameEnter = (e) => {
    e.preventDefault();
    if (materialInputListNameChange !== '' && e.key === 'Enter') {
      refreshMaterialList(); // null이 아니면 실행됨
    }
    else {
      setMateriaInputList([]);
    }
  };

  //조회버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      공장구분: materialInputListGojangGubun ? materialInputListGojangGubun : null,   //공장구분
      업체코드: supplier.value ? supplier.value : null,   //업체코드
      자재규격: evValue.get("materialCode") ? evValue.get("materialCode") : null, //자재규격
      자재구분: evValue.get("materialGubun") ? evValue.get("materialGubun") : null, //자재구분
      시작일자: startDate ? startDate : null,   //자재입고시작일자
      끝날일자: endDate ? endDate : null,   //자재입고끝날일자
      결재지월: groupbyGuljeDal ? groupbyGuljeDal : null, //자재결재지급월
      합계선택: groupby ? groupby : '',   //합계선택 ,개별,규격,업체
      입고출고: materialInputListIpChulGubun,   //입고출고구분
    }

    setCellEditMigul(DataSerche) // cell 수정 api저장
    console.log(cellEditMigul);

    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/MaterialsInputList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, {
      params: {
        materialGojang: DataSerche.공장구분,
        materialUpcheCode: DataSerche.업체코드,
        materialCode: DataSerche.자재규격,
        materialGubun: DataSerche.자재구분,
        materialStartDate: DataSerche.시작일자,   //시작일자
        materialEndDate: DataSerche.끝날일자,     //끝날일자
        materialGuljeDal: DataSerche.결재지월,     //결지지급월
        materialGroupby:DataSerche.합계선택,              //합계선택
        materialIpChulGubun: DataSerche.입고출고       //자재입고출고 구분
      }
    })
      .then((res) => {
        setMateriaInputList(res.data);
      })

      console.log(materialInputList);
  };

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const meterialAPI = useCallback(() => {
    const url = '/api/MaterialsInputList/';
    const url01 = `/api/MaterialsInputList/${materialInputListEditValue.Id}/`; //수정후 Id 쿼리 요청
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: {materialInputGongjang:materialInputListGojangGubun, materialInputName: materialInputListNameChange, materialStartDate: startDate, materialEndDate: endDate } }),
      fetchAllId: () => axios.get(url01, { params: { id: materialInputListEditValue.Id } }), //조건조회요청
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          //alert('정상적으로 저장되었습니다.');
          Swal.fire({
            title: "<h5 style='color:blue'>정상적으로 저장되었습니다.</h5>",
            timer: 1500,
            confirmButtonText: "나가기",
          })
          // console.log(res.data)
        }).catch(error => {
          //alert("[규격[과 [업체명]이 동일할수가 없습니다[중복확인] Or 업체등록에 자재수불확인.")
          Swal.fire({
            title: "<h5 style='color:red'>집계방법이[개별]이 되어야 합니다. Or 집계방법[개별]확인,업체등록에 자재수불확인.</h5>",
            confirmButtonText: "확인필요",
          })
          // console.log(error);
        }),
      update: (id, updatedRecord) =>
        axios.put(url + id, updatedRecord).then((res) => {
          //alert('정상적으로 수정되었습니다.');
          Swal.fire({
            title: "<h5 style='color:blue'>정상적으로 수정되었습니다.</h5>",
            timer: 1500,
            confirmButtonText: "나가기",
          })
        }).catch(error => {
          //alert("수정이 안되고 있습니다[중복확인하시길 바랍니다].")
          Swal.fire({
            title: "<h5 style='color:red'>수정이 안되고 있습니다[중복확인하시길 바랍니다]</h5>",
            confirmButtonText: "확인필요",
          })
          // console.log(error);
        }),
      delete: (id) => axios.delete(url + id).then((res) => {
        //alert("정상적으로 삭제가 실행했습니다.")
        Swal.fire({
          title: "<h5 style='color:blue'>정상적으로 삭제가 실행했습니다.</h5>",
          timer: 1500,
          confirmButtonText: "나가기",
        })
      }).catch(error => {
        //alert("삭제가 실패했습니다.")
        Swal.fire({
          title: "<h5 style='color:red'>삭제가 실패했습니다.</h5>",
          confirmButtonText: "확인필요",
        })
        // console.log(error);
      }),
      // download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [endDate, headers, materialInputListEditValue.Id, materialInputListGojangGubun, materialInputListNameChange, startDate]);

  const refreshMaterialList = useCallback(async () => {
    await meterialAPI()
      .fetchAll()
      .then((res) => {
        setMateriaInputList(res.data);
      })
      .catch((err) => console.log(err));
  }, [meterialAPI]);

  //수정후 Id 쿼리
  const refreshMaterialListId = useCallback(async () => {
    await meterialAPI()
      .fetchAllId()
      .then((res) => {
        setMateriaInputList(res.data);
      })
      .catch((err) => console.log(err));
  }, [meterialAPI]);

  const addOrEdit = useCallback(async (formData) => {
    if (formData.get('Id') === '0')
      await meterialAPI().create(formData)
        .then(res => {
          refreshMaterialList();
        })
        .catch(err => {
          console.log(err)
        })
    else
      await meterialAPI().update(formData.get('Id'), formData)
        .then(res => {
          refreshMaterialListId()
          // console.log(res.data)
        })
        .catch(err => {
          console.log(err)
        })
  }, [meterialAPI, refreshMaterialList, refreshMaterialListId])

  //삭제처리
  const onDelete = useCallback(() => {
    meterialAPI()
      .delete(materialInputListDeleteValue.Id)
      .then((res) => refreshMaterialList())
      .catch((err) => console.log(err));
  }, [materialInputListDeleteValue.Id, meterialAPI, refreshMaterialList]);


  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      {
        name: "edit", header: "수정", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
        }
      },
      { name: "Id", header: "Id", align: "left", width: 50 },
      { name: "ms_공장구분", header: "공장", align: "center", width: 70 },
      { name: "ms_자재코드", header: "코드", align: "center", width: 55 },
      { name: "ms_자재품번", header: "품번", align: "left", width: 70 },
      { name: "ms_자재지출분류", header: "지출분류", align: "left", width: 82,
        // validation: { required: true },
        renderer: {
          styles: {
            // fontWeight: 'bold',
            fontSize: '12px',
            color: (props) => props.value === '고정비용' ? '#e57373' : props.value === '변동비용' ? 'forestgreen' : props.value === '자동이체' ? 'blue' :  props.value === '세액비용' ? '#c71585':props.value === '개인비용지출' ? '#daa520':''
          }
        }
      },

      { name: "ms_자재규격", header: "내용[규격]", align: "left", width: 218 },
      { name: "ms_단위", header: "단위", align: "center", width: 55 },
      { name: "ms_단위량", header: "단위량", align: "center", width: 55 },
      {
        name: "ms_자재단가", header: "단가", align: "right", width: 70,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_수량", header: "입고량", align: "right", width: 100,
        formatter: function (ev) {
          return `<div style="color:green;">${ev.value.toLocaleString('ko-KR')}</div>`
        }
      },
      {
        name: "ms_금액", header: "공급가액", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_세액", header: "세액", align: "right", width: 80,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "계산서", header: "세금계산서", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_입출일자", header: "입출일자", align: "center", width: 80,
        formatter: function (ev) {
          ev.backgroundColor = colors.red;
          if (ev.value !== "날짜빈값") {
          return `<div style="color:green;">${moment(ev.value, "YYYY-MM-DD a hh:mm").format('YYYY-MM-DD')}</div>`
          }
        }
      },
      { name: "ms_업체코드", header: "코드", align: "center", width: 50 },
      { name: "ms_업체명", header: "업체명", align: "left", width: 130 },
      {
        name: "ms_결재지급금액", header: "지급액", align: "right", width: 100,
        editor: {
          type: 'text',
        },
        //Cell 변경시
        onAfterChange(ev) {
          const materialsInputModel = gridRef.current.getInstance().getRow(ev.rowKey)
          const url = '/api/MaterialsInputList/';
          axios.patch(url + materialsInputModel.id, materialsInputModel).then((res) => {
            editRendering(); // 수정완료시 API호출 후 재랜더링 실행됨
            // alert('정상적으로 수정되었습니다.');
          }).catch(error => {
            alert("Cell수정이 안되고 있습니다.")
            // console.log(error);
          })
        },
        validation: {
          required: true,
          dataType: 'number',
          min: 0,
          max: 100000000  //1억
        },
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        },
      },
      {
        name: "ms_결재지급월", header: "결재월", align: "center", width: 70,
        editor: {
          type: 'text',
        },
        //Cell 변경시
        onAfterChange(ev) {
          const materialsInputModel = gridRef.current.getInstance().getRow(ev.rowKey)
          const url = '/api/MaterialsInputList/';
          axios.patch(url + materialsInputModel.id, materialsInputModel).then((res) => {
            // alert('정상적으로 수정되었습니다.');
          }).catch(error => {
            alert("Cell수정이 안되고 있습니다.")
            // console.log(error);
          })
        },
        validation: {
          required: true,
          dataType: 'number',
          min: 200001,  //2000년01월 부터
          max: 203012   //2023년12월까지
        }
      },
      {
        name: "ms_결재유무", header: "결재", align: "center", width: 60,
        copyOptions: {
          useListItemText: true
        },
        formatter: 'listItemText',
        editor: {
          type: 'radio',
          options: {
            listItems: [
              { text: '미결', value: '미결' },
              { text: '보류', value: '보류' },
              { text: '결재', value: '결재' },
              { text: '즉시', value: '즉시' },
            ]
          }
        },
        //Cell 변경시
        onAfterChange(ev) {
          const materialsInputModel = gridRef.current.getInstance().getRow(ev.rowKey)
          const url = '/api/MaterialsInputList/';
          axios.patch(url + materialsInputModel.id, materialsInputModel).then((res) => {
            // alert('정상적으로 수정되었습니다.');
          }).catch(error => {
            alert("Cell수정이 안되고 있습니다.")
            // console.log(error);
          })
        },
        validation: { required: true },
        renderer: {
          styles: {
            // fontWeight: 'bold',
            fontSize: '12px',
            color: (props) => props.value === '미결' ? '#e57373' : props.value === '보류' ? 'LimeGreen' : props.value === '결재' ? '#388e3c' : props.value === '즉시' ? 'blue' : '#ccc'
          }
        }
      },
      // {
      //   name: 'ms_결재유무', header: "결재", align: "center", width: 50, // 전체칼럼 색상적용 css애 적요함. className: 'gross-color',
      //   copyOptions: {
      //     useListItemText: true
      //   },
      //   formatter: 'listItemText',
      //   editor: {
      //     type: 'text',
      //     options: {
      //       listItems: [
      //         { text: '<div style="color:red;">미결</div>', value: '미결' },
      //         { text: '<div style="color:LimeGreen">보류</div>', value: '보류' },
      //         { text: '<div style="color:blue; font-weight: 550;">지급</div>', value: '지급' },
      //       ]
      //     }
      //   }

      // },
      {
        name: "ms_결재지급일자", header: "지급일자", align: "center", width: 80,
        calendar: {
          showToday: true
        },
        editor: {
          type: 'text',
          options: {
            language: 'ko',
            format: 'yyyy-MM-dd',
          }
        },
        formatter: function (ev) {
          if (ev.value !== "날짜빈값") {
            if (ev.value === null) {
              return ev.value === null ? "" : `${moment(ev.value).format('YYYY-MM-DD')}`
            }
            else {
              return ev.value === "" ? "" : `${moment(ev.value).format('YYYY-MM-DD')}`
            }
        }
        },
        //Cell 변경시
        onAfterChange(ev) {
          const materialsInputModel = gridRef.current.getInstance().getRow(ev.rowKey)
          const url = '/api/MaterialsInputList/';
          axios.patch(url + materialsInputModel.id, materialsInputModel).then((res) => {
            // alert('정상적으로 수정되었습니다.');
          }).catch(error => {
            alert("Cell수정이 안되고 있습니다.")
            // console.log(error);
          })
        },
        validation: {
          required: true,
          dataType: 'datePicker',
          min: 20000101,  //2000년01월 부터
          max: 20301231   //2023년12월까지
        }
      },
      {
        name: "미결금액", header: "미결금액", align: "right", width: 101,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        },
      },
      { name: "ms_자재설명", header: "Discription", align: "left", width: 200 },
      { name: "ms_자재수불", header: "수불", align: "center", width: 70 },
      { name: "ms_자재구분", header: "공정", align: "center", width: 50 },
      { name: "ms_입고출고구분", header: "입출", align: "center", width: 50 },
      { name: "ms_계정과목코드", header: "코드", align: "center", width: 50 },
      { name: "ms_계정과목내용", header: "내용", align: "left", width: 90 },
      {
        name: "ms_등록일자", header: "등록일자", align: "center", width: 110,
        formatter: function (ev) {
          //console.log(`등록일자:  ${ev.value}`)
          if (ev.value !== "날짜빈값") {
            return `${moment(ev.value, "YYYY-MM-DD T hh:mm").format('YYYYMMDD HH:mm')}`
          }

        }
      },
      { name: "ms_등록자", header: "등록자", align: "center", width: 70 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = materialInputList.map((row, index) => ({
    id: row.id,
    No: index + 1,
    edit: '수정',
    // print: '인쇄',
    Id: row.id,
    ms_공장구분: row.ms_공장구분,
    ms_자재코드: row.ms_자재코드,
    ms_자재품번: row.ms_자재품번 === 'null' ? '' : row.ms_자재품번,
    ms_자재지출분류: row.ms_자재지출분류,
    ms_자재규격: row.ms_자재규격,
    ms_단위: row.ms_단위,
    ms_단위량: row.ms_단위량,
    ms_자재단가: row.ms_자재단가 === 'null' ? '' : Number(row.ms_자재단가) ,
    ms_수량: Number(row.ms_수량),
    ms_금액: Number(row.ms_금액),
    ms_세액: Number(row.ms_세액),
    계산서: Number(row.ms_금액) + Number(row.ms_세액),
    ms_입출일자: row.ms_입출일자 === '0001-01-01' ? '9999-01-01' : row.ms_입출일자,
    ms_업체코드: row.ms_업체코드,
    ms_업체명: row.ms_업체명,
    ms_자재수불: row.ms_자재수불,
    ms_자재구분: row.ms_자재구분,
    ms_입고출고구분: row.ms_입고출고구분,
    ms_계정과목코드: row.ms_계정과목코드,
    ms_계정과목내용: row.ms_계정과목내용,
    ms_결재지급월: row.ms_결재지급월,
    ms_결재지급금액: Number(row.ms_결재지급금액),
    ms_결재유무: row.ms_결재유무,
    ms_결재지급일자: row.ms_결재지급일자 === '0001-01-01' ? '9999-01-01' : row.ms_결재지급일자,
    미결금액: (Number(row.ms_결재지급금액) - (Number(row.ms_금액) + Number(row.ms_세액))),
    ms_자재설명: row.ms_자재설명 === 'null' ? '' : row.ms_자재설명,
    ms_등록일자: row.ms_등록일자,
    ms_등록자: row.ms_등록자 === 'null' ? '' : row.ms_등록자,
    delete: '삭제'
  }));

  //그리드 합계부분
  const summary = {
    height: 30,
    position: 'bottom', // or 'top'
    columnContent: {
      edit: {
        template(summary) {
          return '<div align="center">합계</div>';
        }
      },
      // ms_자재단가: {
      //   template(summary) {
      //     return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
      //   }
      // },
      ms_수량: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_세액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      계산서: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_결재지급금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      미결금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
    },
  };


  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '구매자재정보',
        name: '구매자재정보',
        childNames: ['ms_자재코드', 'ms_자재품번','ms_자재지출분류', 'ms_자재규격']
      },
      {
        header: '구매자재[단위기준]',
        name: '구매자재[단위기준];',
        childNames: ['ms_단위', 'ms_단위량', 'ms_자재단가']
      },
      {
        header: '구매자재입고',
        name: '구매자재입고',
        childNames: ['ms_수량', 'ms_금액', 'ms_입출일자', 'ms_세액', '계산서']
      },
      {
        header: '구매자재업체',
        name: '구매자재업체',
        childNames: ['ms_업체코드', 'ms_업체명']
      },
      {
        header: '자재처리구분',
        name: '자재처리구분',
        childNames: ['ms_자재수불', 'ms_자재구분', 'ms_입고출고구분']
      },
      {
        header: '계정과목',
        name: '계정과목',
        childNames: ['ms_계정과목코드', 'ms_계정과목내용']
      },
      {
        header: '구매자재결재현황',
        name: '구매자재결재현황',
        childNames: ['ms_결재지급월', 'ms_결재지급금액', 'ms_결재유무', 'ms_결재지급일자', '미결금액']
      },
    ]
  }

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      // border: 'red',
      border: '#42a5f5', //세로선 색상
    },
    outline: {
      // border: 'blue',
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        // background: '#C0C0C0',
        // border: '#C0C0C0',
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'blue',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        // background: '#D8D8D8'
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = materialInputListSelectData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );

  //Grid 클릭처리
  const handleEditClick = ((ev) => {
    var rowKey = ev.rowKey
    // console.log(rowKey)
    const clickToastGridValue = gridRef.current.getInstance().getRow(ev.rowKey)
     console.log(clickToastGridValue)

    if (ev.rowKey === rowKey && ev.columnName === 'edit') {
      // console.log(clickToastGridValue)
      setMaterialInputListEditValue(clickToastGridValue);
      setMaterialInputListEditModal(true);
    }
    else if (ev.rowKey === rowKey && ev.columnName === 'delete') {
      //  console.log(clickToastGridValue)
      setMaterialInputListDeleteValue(clickToastGridValue);
      setMaterialInputListDeleteModal(true);
    }
    else {
      console.log('Grid 해당클릭필드가 아님');
    }
  })

  //Grid 더블클릭
  const handleEditDbClick = ((ev) => {
    var rowKey = ev.rowKey
    const clickToastGridValue = gridRef.current.getInstance().getRow(ev.rowKey)
    // console.log(clickToastGridValue)
    if (ev.rowKey === rowKey && ev.columnName === 'ms_결재유무') {
      setMaterialInputListEditValue(clickToastGridValue);
      setMaterialInputListEditDbClickModal(true)
      console.log('결재유무확인');
    }
    else {
      console.log('Grid 더블클릭필드가 아님');
    }
  })

  // //Cell 수정
  // const handlEditingFinish = ((ev) => {
  // var rowKey = ev.rowKey
  // // console.log(rowKey)
  // const clickToastGridValue = gridRef.current.getInstance().getRow(ev.rowKey)
  // // console.log(clickToastGridValue)
  // if (ev.rowKey === rowKey && ev.columnName === 'ms_결재지급금액') {
  //   setcellEditMigul(clickToastGridValue)
  //   console.log(cellEditMigul)
  // }
  // })

//엑셀파일내보내기
    const exportExcelFile = () => {
      console.log(rows)
      console.log(rows[0].id)
      const workbook = new ExcelJS.Workbook();
      const sheet =  workbook.addWorksheet(("자재매입현황리스트"),{
        //페이지설정
        pageSetup: {
          paperSize: 9, //A4
          orientation: 'landscape', //가로
          horizontalCentered: true, //가운데출력
        },
        views: [{ state: "frozen", ySplit: 4 }], // 틀고정
      }
    );

    //여백설정
    sheet.pageSetup.margins = {
      left: 0.1,
      right: 0.1,
      top: 0.75,
      bottom: 0.5,
      header: 0.3,
      footer: 0.3,
    };
    sheet.pageSetup.printTitlesColumn = "4:4"; //출력시 고정혜드
    sheet.headerFooter.oddFooter = "&RPage &P / &N    "; //바닥글
    sheet.properties.defaultRowHeight = 20;

      //엑셀타이틀넣기
      sheet.getCell(`A1`).value = `${rows[0].id !== undefined ? "자재매입현황리스트" : "자재매입[누계]현황리스트"}`;
      sheet.mergeCells(`A1:K2`);
      sheet.getCell(`A1`).alignment = { horizontal: 'center', vertical: "middle"};
      sheet.getCell(`A1`).font= { size: 20, bold: true, color: { argb: "ff1890ff" }} ;
      sheet.getRow(1).height = 20; //높이설정
      //개별라인긋기
      sheet.getCell(`L1`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
      //가운데정렬
      sheet.getCell(`L1`).alignment={
        vertical: "middle",
        horizontal: "center",
      }

      sheet.getCell(`M1`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
        //가운데정렬
      sheet.getCell(`M1`).alignment={
        vertical: "middle",
        horizontal: "center",
      }
      sheet.getCell(`N1`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
        //가운데정렬
      sheet.getCell(`N1`).alignment={
        vertical: "middle",
        horizontal: "center",
      }

      sheet.getCell(`L2`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
      sheet.getCell(`M2`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
      sheet.getCell(`N2`).border = {
        top: { style: "thin", color: { argb: "FF1890FF" } },
        left: { style: "thin", color: { argb: "FF1890FF" } },
        bottom: { style: "thin", color: { argb: "FF1890FF" } },
        right: { style: "thin", color: { argb: "FF1890FF" } },
      }
      //개별가운데정렬


      sheet.getCell(`L1`).value = "작성";
      sheet.getCell(`M1`).value = "검토";
      sheet.mergeCells(`N1:O1`);
      sheet.getCell(`N1`).value = "승인";
      sheet.mergeCells('N2:O2');
      sheet.getRow(2).height = 30; //높이설정


      //두번째라인 0번째 빈공간생성
      sheet.spliceRows(3, 0, []);
      sheet.getCell(`A3`).value = "작성자No:";
      sheet.getCell(`B3`).value = `${pwNoName}`;
      sheet.getCell(`L3`).value = "출력일자:";
      sheet.mergeCells('M3:O3');
      sheet.getCell(`M3`).value = format(Date.now(),'yyyy-MM-dd hh:mm') ;

      const styleHeaderCell = (cell) => {
        cell.fill = {
          type: 'gradient',
          gradient: 'path',
          center:{left:0.5,top:0.5},
          stops: [
              {position:0, color:{argb:'CFF2C9'}},
              {position:1, color:{argb:'CFF2C9'}}
          ]
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FF1890FF" } },
          left: { style: "thin", color: { argb: "FF1890FF" } },
          bottom: { style: "thin", color: { argb: "FF1890FF" } },
          right: { style: "thin", color: { argb: "FF1890FF" } },
        };
        cell.font = {
          name: "Arial",
          size: 10,
          bold: true,
          color: { argb: "ff252525" },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      };

      const headerRow = sheet.addRow(["공장","내용[규격]","지출분류", "코드", "업체명","단위","단위량","단가","매입량","매입금액","세액","계산서금액","매입일자","기타","결재"]);
      const headerWidths = [10,10,8,5,20,4,6,8,10,10,8,12,10,9,4];
        headerRow.eachCell((cell, colNum) => {
          styleHeaderCell(cell);
          sheet.getColumn(colNum).width = headerWidths[colNum - 1];
        });


      rows.forEach(({ms_공장구분,ms_자재규격, ms_자재지출분류, ms_업체코드, ms_업체명,ms_단위,ms_단위량,ms_자재단가,ms_수량,ms_금액,ms_세액,ms_입출일자,ms_자재설명,ms_결재유무}) => {
        const rowDatas = [ms_공장구분,ms_자재규격, ms_자재지출분류,Number(ms_업체코드), ms_업체명,
                         (ms_단위 === undefined ? "": ms_단위),
                         (ms_단위량 === undefined ? "" : Number(ms_단위량)),
                         (ms_자재단가 === "" ? "" :Number(ms_자재단가)),
                         Number(ms_수량),
                         ms_금액,
                         Number(ms_세액),
                         Number(`${ms_금액 + ms_세액}`),
                         ms_입출일자 === "날짜빈값" ? "":format(Date.parse(ms_입출일자),'yyyy-MM-dd'),
                         (ms_자재설명 === undefined ? "":ms_자재설명 === null ? "" : ms_자재설명 ),
                         ms_결재유무];
        const appendRow = sheet.addRow(rowDatas);
        const styleDataCell = (cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "ffffffff" },
            };
            cell.border = {
              top: { style: "thin", color: { argb: "FF1890FF" } },
              left: { style: "thin", color: { argb: "FF1890FF" } },
              bottom: { style: "thin", color: { argb: "FF1890FF" } },
              right: { style: "thin", color: { argb: "FF1890FF" } },

              // top: {style:'double', color: {argb:'FF00FF00'}},
              // left: {style:'double', color: {argb:'FF00FF00'}},
              // bottom: {style:'double', color: {argb:'FF00FF00'}},
              // right: {style:'double', color: {argb:'FF00FF00'}}
            };
            cell.font = {
              name: "Arial",
              size: 10,
              color: { argb: "ff252525" },
            };
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
          };

          appendRow.eachCell((cell, colNum) => {
          styleDataCell(cell, colNum);
            if (colNum === 1) {
              cell.font = {
                name: "Arial",
                size: 10,
                color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
            }
            if (colNum === 5) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "left",
                wrapText: true,
              };
            }
            if (colNum === 7) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 8) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 9) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 10) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 11) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 12) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "right",
                wrapText: true,
              };
              cell.numFmt = "#,##0";
            }
            if (colNum === 13) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
            }
            if (colNum === 14) {
              cell.font = {
                name: "Arial",
                size: 10,
                // color: { argb: "ff1890ff" },
              };
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
            }
        });
      });

        //합계라인
        const endRow = sheet.lastRow._number + 1;

        sheet.getCell(`A${endRow}`).value = "합계"
        sheet.getCell(`A${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`A${endRow}`).alignment = { horizontal: 'center' }
        sheet.getCell(`A${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`A${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`A${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}

        // sheet.getCell(`B${endRow}`).value = "갯수"
        sheet.getCell(`B${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`B${endRow}`).value = { formula: `COUNT(L3:L${endRow - 1})` }
        sheet.getCell(`B${endRow}`).alignment = { horizontal: 'center' }
        sheet.getCell(`B${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`B${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`B${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}
        //단위량
        sheet.getCell(`G${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`G${endRow}`).value = { formula: `SUM(G3:G${endRow - 1})` }
        sheet.getCell(`G${endRow}`).alignment = { horizontal: 'right' }
        sheet.getCell(`G${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`G${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`G${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}
        //단가
        sheet.getCell(`H${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`H${endRow}`).value = { formula: `SUM(H3:H${endRow - 1})` }
        sheet.getCell(`H${endRow}`).alignment = { horizontal: 'right' }
        sheet.getCell(`H${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`H${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`H${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}
        //매입량
        sheet.getCell(`I${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`I${endRow}`).value = { formula: `SUM(I3:I${endRow - 1})` }
        sheet.getCell(`I${endRow}`).alignment = { horizontal: 'right' }
        sheet.getCell(`I${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`I${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`I${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}

        //매입금액
        sheet.getCell(`J${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`J${endRow}`).value = { formula: `SUM(J3:J${endRow - 1})` }
        sheet.getCell(`J${endRow}`).alignment = { horizontal: 'right' }
        sheet.getCell(`J${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`J${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`J${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "-100000f" } },}

        //세액
        sheet.getCell(`K${endRow}`).font = { name: "Arial", size: 10, color: { argb: "ff252525" }}
        sheet.getCell(`K${endRow}`).value = { formula: `SUM(K3:K${endRow - 1})` }
        sheet.getCell(`K${endRow}`).alignment = { horizontal: 'right' }
        sheet.getCell(`K${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`K${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`K${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}

        //계산서금액
        sheet.getCell(`L${endRow}`).font = { name: "Arial", size: 11, color: { argb: "ff252525" }}
        sheet.getCell(`L${endRow}`).value = { formula: `SUM(L3:L${endRow - 1})` }
        sheet.getCell(`L${endRow}`).alignment = { horizontal: 'right'}
        sheet.getCell(`L${endRow}`).numFmt = '[Green]#,##0;[Red]-#,##0'
        sheet.getCell(`L${endRow}`).fill = { type: "pattern",  pattern: "solid", fgColor: { argb: "ffffffff" }}
        sheet.getCell(`L${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },}

        //마지막 첫번재 합계부분
        sheet.getCell(`C${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`D${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`E${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`F${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`M${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`N${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        sheet.getCell(`O${endRow}`).border = {left: { style: "thin", color: { argb: "ff1890ff" } },top: { style: "double", color: { argb: "ff1890ff" } },
                                              bottom: { style: "thin", color: { argb: "ff1890ff" } },right: { style: "thin", color: { argb: "ff1890ff" } },
        }
        //합계라인 끝부분


      //파일저장
      workbook.xlsx.writeBuffer().then(function (data) {
          const timestamp ="구매매입리스트" + format(Date.now(),'yyyyMMddhhmm_ss');
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = `${timestamp}.xlsx`;
          anchor.click();
          window.URL.revokeObjectURL(url);
      });
    }

  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매자재[입고출고]등록</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12" >
              <FormControl
                variant="outlined"
                style={{ minWidth: 100, float: 'center', marginRight: '2px', }}
                size="small"
              >
                <InputLabel>우리공장</InputLabel>
                <Select
                  variant="outlined"
                  value={materialInputListGojangGubun ? materialInputListGojangGubun : ''}
                  onChange={materialInputListGongjangGubunHandle}
                  label="우리공장"
                >
                  <MenuItem value=""><div style={{ color: 'red' }}>값없음</div></MenuItem>
                  <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                  <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                </Select>
              </FormControl>

              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ''}
                size="small"
                style={{ width: 180, marginRight: 3 }}
                value={supplier ? supplier : setSupplier({ label: '', value: '' })}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="구매업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 120, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="구매자재규격"
                name="materialCode"
                value={materialInputListCode}
                autoComplete={materialInputListCode}
                onChange={haneleMaterialInputListCodeOnChange}
                onClick={haneleMaterialInputListCodeOnClick}
              />
              <TextField
                style={{ width: 120, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재처리공정"
                name="materialGubun"
                value={materialInputListGubun}
                autoComplete={materialInputListGubun}
                onChange={haneleMaterialInputListGubunOnChange}
                onClick={haneleMaterialGubunOnClick}
              />
                 <TextField
                style={{ width: 100, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="결재월"
                name="materialGubun"
                value={groupbyGuljeDal}
                autoComplete={groupbyGuljeDal}
                onChange={haneleGroupbyGuljeDalOnChange}
                onClick={haneleGroupbyGuljeDalOnClick}
              />
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: '0px', marginRight: "2px", float: "center" }}
                label="입출시작일자"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: '0px', marginRight: "2px", float: "center" }}
                label="입출끝날일자"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <FormControl
                variant="outlined"
                style={{ minWidth: 100, float: 'center', marginRight: '12px', }}
                size="small"
              >
                <InputLabel>집계방법</InputLabel>
                <Select
                  variant="outlined"
                  value={groupby ? groupby : ''}
                  onChange={materialInputListGroupbyGubunHandle}
                  label="집계방법"
                >
                  <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                  <MenuItem value={'개별'}>개별</MenuItem>
                  <MenuItem value={'규격'}>규격</MenuItem>
                  <MenuItem value={'업체STD'}>업체별내용SUM</MenuItem>
                  <MenuItem value={'업체SUM'}>업체별합계SUM</MenuItem>
                </Select>
              </FormControl>

              <RadioGroup row value={materialInputListIpChulGubun} onChange={haneleMaterialInputListIpChulGubunOnChange} >
                <FormControlLabel labelPlacement='end' classes={{ label: classes.label }} control={customRadio} value="입고" label="입고" />
                <FormControlLabel labelPlacement='end' classes={{ label: classes.label }} control={customRadio} value="출고" label="출고" />
              </RadioGroup>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 100,
                  marginLeft: 0,
                  marginRight: 3,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                variant="contained"
                startIcon={<InsertDriveFileIcon />}
                style={{
                  background: '#00838f',
                  color: 'white',
                  height: 36,
                  width: 100,
                  marginRight: 3,
                  float: "center",
                }}
                onClick={() => {
                  setMaterialInputListCreateModal(true)
                }}
              >
                등록
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 100,
                  float: "center",
                }}
                onClick={() => {
                  window.location.href = "/home/index";
                }}
              // onClick={() => { history.goBack(); }}  //이게 더빠름
              >
                홈이동
              </Button>

              <Button
                id="homemove"
                variant="contained"
                startIcon={<LocationCitySharpIcon />}
                style={{
                  background: '#b45f06',
                  color: 'white',
                  height: 36,
                  width: 135,
                  marginLeft: 18,
                  marginRight: 3,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/Suppliers/PurchaseList');
                  // Swal.fire({
                  //   title: "<h5 style='color:red'>박전무에게 문의하세요. 숙지될때까지 막습니다.</h5>",
                  //   confirmButtonText: "실행막음",
                  // })
                }}
              >
                업체등록이동
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<ListAltIcon />}
                style={{
                  background: '#1565c0',
                  color: 'white',
                  height: 36,
                  width: 135,
                  float: "center",
                }}
                onClick={() => {
                  history.push('/Purchases/Materials/MaterialList');
                  // Swal.fire({
                  //   title: "<h5 style='color:red'>박전무에게 문의하세요. 숙지될때까지 막습니다.</h5>",
                  //   confirmButtonText: "실행막음",
                  // })
                }}
              >
                자재등록이동
              </Button>
              {
                rows.length !== 0 ?
                  <Button
                    // startIcon={<FeaturedPlayListIcon />}
                    style={{background:"blue",color:'white',paddingRight:'15px', marginLeft:"auto"}}
                    onClick={exportExcelFile}
                  >
                  <img src={excelIcon} style={{ margin: 0, paddingRight:0, width:'30px', height:'25px'}}  alt='' />
                    엑셀저장
                  </Button>
                : null
              }
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="materialInputNameChange"
          value={materialInputListNameChange}
          onChange={handleMaterialInputListNameChange}
          onKeyUp={handleMaterialInputListNameEnter}
          // onClick={() => {
          //   if (materialInputListNameChange !== '' && supplier !== null && materialInputListCode !== null && materialInputListGubun !== null) {
          //     setMaterialInputListNameChange('');
          //     setSupplier('')
          //     setMaterialInputListCode('')
          //     setMaterialInputListGubun('')
          //   }
          // }}
        />
      </div>

      <Container maxWidth="xl" style={{ padding: '0px 20px 0px 20px' }}>
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            summary={summary}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={29}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50, //첫번째 칼럼의 넗이
              frozenCount: 8, // 7개의 컬럼을 고정하고
              frozenBorderWidth: 1, // 고정 컬럼의 경계선 너비를 2px로 한다.
              resizable: true,
            }}
            ref={gridRef}
            onClick={handleEditClick}
            onDblclick={handleEditDbClick}
          // onChange={handlEditingFinish}
          />
        </Box>
      </Container>
      {materialInputListCreateModal === true ? <MaterialInputListCreate materialInputListCreateModal={materialInputListCreateModal} setMaterialInputListCreateModal={setMaterialInputListCreateModal}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListEditModal === true ? <MaterialInputListEdit materialInputListEditModal={materialInputListEditModal} setMaterialInputListEditModal={setMaterialInputListEditModal}
        materialInputListEditValue={materialInputListEditValue} setMaterialInputListEditValue={materialInputListEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListEditDbClickModal === true ? <MaterialInputListEditDbClick materialInputListEditDbClickModal={materialInputListEditDbClickModal} setMaterialInputListEditDbClickModal={setMaterialInputListEditDbClickModal}
        materialInputListEditValue={materialInputListEditValue} setMaterialInputListEditValue={materialInputListEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListDeleteModal === true ? <MaterialInputListDelete materialInputListDeleteModal={materialInputListDeleteModal} setMaterialInputListDeleteModal={setMaterialInputListDeleteModal}
        materialInputListDeleteValue={materialInputListDeleteValue} setMaterialInputListDeleteValue={materialInputListDeleteValue}
        setMaterialInputListPasswordTrue={setMaterialInputListPasswordTrue}
        urlpw={urlpw} /> : null}

      {matrialInputListMessageModal === true ? <MatrialInputListMessage matrialInputListMessageModal={matrialInputListMessageModal} setMatrialInputListMessageModal={setMatrialInputListMessageModal}
      /> : null}



    </>
  )
}
export default MaterialInputList